const DORMANCY_URL_CONSTANTS = {
    DORMANCY_URL_PATH: '/rekyc/dormancyRemoval',

    DORMANCY_REMOVAL: '/servicing/dormancyRemoval',
    DORMANCY_REMOVAL_SUCCESS: '/servicing/dormancyRemovalRedirect',
    DORMANCY_REMOVAL_HOME: '/servicing/dormancyRemovalProcess',
    DORMANCY_REMOVAL_DATA: '/servicing/dormancyRemovalData',
    DORMANCY_REMOVAL_ERROR_REDIRECT: '/servicing/dormancyRemovalError',
}

export default DORMANCY_URL_CONSTANTS;